import { buildSkillStep } from "@/core/skillForms/builder";
import { Area } from "@/contexts/MessagesContext";

export const legalQuestionSkillStep1 = buildSkillStep({
  description:
    "O Assistente Lexter pode te ajudar a tirar dúvidas, basta inserir a área jurídica e complementar com a sua pergunta.",
  fields: [
    {
      name: "area",
      type: "string",
      options: [
        { label: "Cível", value: Area.CIVIL },
        { label: "Trabalhista", value: Area.LABOR },
        { label: "Previdenciário", value: Area.SOCIAL_SECURITY },
        { label: "Tributário", value: Area.TAX },
        { label: "Criminal", value: Area.CRIMINAL },
        {
          label: "Outros",
          value: Area.OTHER,
        },
      ],
      ui: {
        label: "Área jurídica",
        placeholder: "Selecione a área jurídica",
      },
    },
    {
      name: "custom_area",
      type: "string",
      overrideField: "area",
      ui: {
        label: "Área jurídica",
        placeholder: "Exemplos: Direito Ambiental, Direito Administrativo...",
        widget: "textarea",
      },
      condition: {
        field: "area",
        value: Area.OTHER,
      },
    },
    {
      name: "question",
      type: "string",
      ui: {
        label: "O que você gostaria de perguntar?",
        placeholder:
          "Exemplo: Houve alguma alteração recente na legislação ou no Regimento Interno do STF que possa afetar o prazo para a interposição do Agravo Regimental?",
        widget: "textarea",
      },
    },
  ],
  submitButtonText: "Perguntar",
});
